import { create } from 'zustand'

type LoginDialogStoreType = {
  isOpen: boolean
  next?: string
  open: () => void
  close: () => void
  toggle: () => void
}

const useLoginDialogStore = create<LoginDialogStoreType>(set => ({
  isOpen: false,
  next: undefined,
  open: (next?: string) => set({ isOpen: true, next }),
  close: () => set({ isOpen: false, next: undefined }),
  toggle: (next?: string) => set(state => ({ isOpen: !state.isOpen, next }))
}))

export default useLoginDialogStore
